import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/core/locales/i18n";
import axios from "axios";
import "bootstrap";
import Vuelidate from "vuelidate";
import { BootstrapVue } from "bootstrap-vue";
import { axiosInstance } from "@/core/client/http-client";
import HeaderBody from "@/components/HeaderBody";
import ButtonAsync from "@/components/ButtonAsync";
import LoadingScreen from "@/components/LoadingScreen";
import ChatBot from "@/components/ChatBot";
import moment from "moment";
import VueMoment from "vue-moment";
require("moment/locale/ja");
moment.locale("ja");

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMoment, { moment });
Vue.component("ChatBot", ChatBot);
Vue.component("LoadingScreen", LoadingScreen);
Vue.component("HeaderBody", HeaderBody);
Vue.component("ButtonAsync", ButtonAsync);

Vue.directive("active-validate", {
  bind: function(el, binding) {
    el.addEventListener("input", function(event) {
      if (event.target.value) {
        binding.value && binding.value();
      }
    });
  }
});

Vue.config.productionTip = false;

// Setup axios to be available globally through Vue
Vue.axios = Vue.prototype.$http = axiosInstance;

export const app = new Vue({
  el: "#page",
  router,
  i18n,
  store,
  render: h => h(App)
});

window.axios = axios;
